// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68693753","455":"667158a2","644":"e0763abe"}[chunkId] + ".chunk.js";
};